import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dashboard-stats"
export default class extends Controller {
  static targets = ["skeleton", "content", "error"]
  
  connect() {
    // Handle Turbo Frame events for loading states
    this.element.addEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))
    this.element.addEventListener("turbo:frame-render", this.handleFrameRender.bind(this))
    this.element.addEventListener("turbo:visit-error", this.handleError.bind(this))
    
    // Add staggered loading effect
    this.addStaggeredLoading()
  }
  
  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))
    this.element.removeEventListener("turbo:frame-render", this.handleFrameRender.bind(this))
    this.element.removeEventListener("turbo:visit-error", this.handleError.bind(this))
  }
  
  handleFrameLoad(event) {
    // Frame has started loading
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add("animate-pulse")
    }
  }
  
  handleFrameRender(event) {
    // Frame has finished rendering
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.remove("animate-pulse")
    }
    
    // Add fade-in animation to content
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("animate-fade-in")
    }
  }
  
  handleError(event) {
    console.error("Error loading dashboard stats:", event.detail)
    
    // Show error state
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden")
      this.errorTarget.innerHTML = `
        <div class="bg-red-50 border border-red-200 rounded-md p-4">
          <div class="flex">
            <div class="shrink-0">
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">Error loading statistics</h3>
              <p class="mt-1 text-sm text-red-700">Unable to load this metric. Please try refreshing the page.</p>
              <button class="mt-2 text-sm font-medium text-red-600 hover:text-red-500" data-action="click->dashboard-stats#retry">
                Retry
              </button>
            </div>
          </div>
        </div>
      `
    }
    
    // Hide skeleton on error
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add("hidden")
    }
  }
  
  retry(event) {
    event.preventDefault()
    
    // Reload the Turbo Frame
    const frame = this.element.querySelector("turbo-frame")
    if (frame) {
      frame.reload()
      
      // Show skeleton again
      if (this.hasSkeletonTarget) {
        this.skeletonTarget.classList.remove("hidden")
      }
      
      // Hide error
      if (this.hasErrorTarget) {
        this.errorTarget.classList.add("hidden")
      }
    }
  }
  
  addStaggeredLoading() {
    // Add a slight delay to each card for a staggered loading effect
    const frames = document.querySelectorAll('turbo-frame[data-controller="dashboard-stats"]')
    frames.forEach((frame, index) => {
      setTimeout(() => {
        frame.loading = "eager"
      }, index * 100) // 100ms delay between each card
    })
  }
}
